import React from 'react'
import { Checkbox } from '@/components/ui/checkbox'
import { Switch } from '@/components/ui/switch'
import { Label } from '@/components/ui/label'
import { cn } from '@/lib/utils'

interface CustomInputProps {
  type: 'checkbox' | 'switch' | 'radio' | 'select' | 'file'
  id: string
  name?: string
  label?: string
  checked?: boolean
  onChange?: (e: any) => void
  disabled?: boolean
  className?: string
}

export const CustomInput: React.FC<CustomInputProps> = ({
  type,
  id,
  label,
  checked,
  onChange,
  disabled,
  className,
}) => {
  if (type === 'switch') {
    return (
      <div className={cn('flex items-center gap-2', className)}>
        <Switch
          id={id}
          checked={checked}
          onCheckedChange={(val) => onChange?.({ target: { checked: val } })}
          disabled={disabled}
        />
        {label && <Label htmlFor={id}>{label}</Label>}
      </div>
    )
  }

  return (
    <div className={cn('flex items-center gap-2', className)}>
      <Checkbox
        id={id}
        checked={checked}
        onCheckedChange={(val) => onChange?.({ target: { checked: val } })}
        disabled={disabled}
      />
      {label && <Label htmlFor={id}>{label}</Label>}
    </div>
  )
}
